// src/components/exploreBooksComponents/TopRatedBooks.jsx
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BookManager from "../../services/home/BookManager";
import SectionHeader from "../../components/home/exploreBooksComponents/SectionHeader";
import BookGrid from "../../components/home/exploreBooksComponents/BookGrid";

export default function TopRatedBooks() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("grid");
  const userId = useSelector((state) => state.auth.user?.userId) || null;

  const fetchTopRated = async () => {
    setLoading(true);
    try {
      // fetch top 20 by default; pass userId for cart/wishlist flags
      const topRated = await BookManager.getTopRatedBooks(20, userId);
      setBooks(topRated);
    } catch (err) {
      console.error("Error fetching top-rated books", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopRated();
  }, [userId]);

  // Map the DTO shape to BookGrid props
  const mappedBooks = books.map((b) => ({
    id: b.bookId,
    title: b.bookName,
    author: b.authorName,         // assuming your DTO includes authorName
    isbn: b.bookIsbn10,           // or bookIsbn13 if you prefer
    description: b.bookDescription || "",
    rating:(b.averageRating || 0),
    image: Array.isArray(b.bookImages) ? b.bookImages[0] : b.image,
    inCart: b.inCart,
    inWishlist: b.inWishlist,
    inStock: b.bookStockStatus,
  }));

  return (
    <div className="min-h-screen bg-white">
      <SectionHeader
        title="Top Rated"
        placeholder="Search top-rated books"
      />

      <div className="container mx-auto px-4 py-2">
        <BookGrid
          books={mappedBooks}
          view={view}
          onViewChange={setView}
          loading={loading}
        />

        {!loading && books.length === 0 && (
          <div className="mt-6 text-center text-gray-500">
            No top-rated books available.
          </div>
        )}
      </div>
    </div>
  );
}
